import React from 'react';
import Proptypes from 'prop-types';
import withMediaQuery from 'components/WithMediaQuery';
import { withStyles } from "tss-react/mui";
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTransition from '../DialogTransition';
import ResponsiveDialogHeader from '../ResponsiveDialogHeader';
import SelectionPanel from '../SelectionPanel';
import classNames from 'classnames';
import styles from './styles';

class SelectionDialog extends React.Component {

    handleClose = () => {
        this.props.handleClose();
    };

    render() {
        const { classes, fullScreen } = this.props;
     
        return (

            <Dialog
                fullScreen={fullScreen}
                onClose={this.props.handleClose}
                TransitionComponent={DialogTransition}
                open={this.props.open}
                className={classNames(classes.dialogRoot, this.props.open ? classes.dialog : '')}>

                <ResponsiveDialogHeader
                    fullScreen={fullScreen}
                    title={this.props.title}
                    handleClose={this.props.handleClose}
                    showBackIcon={false} />

                <DialogContent>
                    <div className={classes.panel}>
                        <SelectionPanel {...this.props} />
                    </div>
                </DialogContent>
            </Dialog>
        );
    }
}

SelectionDialog.propTypes = {
    handleClose: Proptypes.func.isRequired,
    open: Proptypes.bool.isRequired,
    title: Proptypes.string.isRequired
};

const Media = withMediaQuery(theme => theme.breakpoints.down('lg'))(SelectionDialog);
const Styled = withStyles(Media,styles);

export default Styled;